import { addMessages } from '@hana/i18n';

// Khoá chuỗi Ezy › Dịch vụ › Biểu giá (màn rộng + iPad dùng chung). Mã phí, tên riêng và dữ liệu không dịch.
addMessages('vi', {
  'prc.f.wait': 'Chờ duyệt',
  'prc.f.exp': 'Sắp hết hiệu lực',
  'prc.f.below': 'Khách dưới biểu chuẩn',
  'prc.feeCode': '{code} · mã phí',
  'prc.noWrite': 'Chưa mở ghi ở bản này',
  'prc.soon': '{what} chưa mở ở bản này',
  'prc.allSvc': 'Tất cả dịch vụ',
  'prc.title': 'Biểu giá dịch vụ',
  'prc.roleView': 'Xem thử theo vai',
  'prc.mgr': 'Quản lý',
  'prc.imp': 'Nhập Excel',
  'prc.exp': 'Xuất Excel',
  'prc.history': 'Lịch sử thay đổi',
  'prc.compare': 'So sánh giá',
  'prc.add': 'Thêm giá',
  'prc.empty': 'Chưa có giá',
  'prc.emptyDesc': 'Biểu giá dịch vụ sẽ hiện ở đây.',
  'prc.retry': 'Thử lại',
  'prc.noperm': 'Không có quyền xem biểu giá.',
  'prc.service': 'Dịch vụ',
  'prc.waitN': '{n} chờ duyệt',
  'prc.paneLabel': 'Biểu giá · {name}',
  'prc.table': 'Bảng giá',
  'prc.t.std': 'Biểu chuẩn',
  'prc.t.cus': 'Giá theo khách / hợp đồng',
  'prc.t.sur': 'Phụ thu theo biểu',
  'prc.rows': 'Số dòng',
  'prc.unfilter': 'Bỏ lọc {f}',
  'prc.unfilterT': 'Bỏ lọc',
  'prc.versions': 'Phiên bản',
  'prc.eff': 'Hiệu lực',
  'prc.allVers': 'Tất cả bản',
  'prc.routePrice': 'Tính giá theo tuyến',
  'prc.openCalc': 'Mở tính giá',
  'prc.c.code': 'Mã',
  'prc.c.fee': 'Tên phí',
  'prc.c.unit': 'Đơn vị',
  'prc.c.calc': 'Cách tính',
  'prc.c.std': 'Giá chuẩn ₫',
  'prc.c.floor': 'Giá sàn ₫',
  'prc.c.incl': 'Đã bao gồm',
  'prc.seePrice': 'Xem giá · {code} · {name} · {unit}',
  'prc.priceDetail': 'Chi tiết giá',
  'prc.calcT': 'Cách tính · {v}',
  'prc.floorT': 'Giá sàn',
  'prc.inclT': 'Đã bao gồm · {v}',
  'prc.noIncl': 'Không có phạm vi bao gồm',
  'prc.surN': '{n} phụ thu theo biểu',
  'prc.nextTip': '{v} · {st} · từ {from} · {p}',
  'prc.none': 'Chưa có giá.',
  'prc.c.cus': 'Khách · hợp đồng',
  'prc.c.cusPrice': 'Giá khách ₫',
  'prc.c.diff': 'Lệch',
  'prc.below': 'Dưới sàn',
  'prc.needApr': 'Cần duyệt giá',
  'prc.apr': 'Đã duyệt giá',
  'prc.belowT': 'Dưới giá sàn {floor} · {who}',
  'prc.waitFor': 'chờ {s}',
  'prc.aprBy': 'đã duyệt · {s}',
  'prc.cusDetail': 'Chi tiết giá khách',
  'prc.seeCus': 'Xem giá khách · {cus} · {code}',
  'prc.openCt': 'Mở hợp đồng {ct}',
  'prc.contract': 'Hợp đồng',
  'prc.vsStd': 'So với giá chuẩn',
  'prc.noCus': 'Chưa có giá theo khách.',
  'prc.c.appl': 'Áp cho',
  'prc.c.item': 'Khoản',
  'prc.c.formula': 'Công thức',
  'prc.c.unitPrice': 'Đơn giá ₫',
  'prc.c.status': 'Trạng thái',
  'prc.noSur': 'Chưa có phụ thu.',
  'prc.trialAria': 'Tính thử phụ thu TRFA',
  'prc.trial': 'Tính thử · TRFA',
  'prc.in.h': 'Lưu mooc · giờ',
  'prc.in.w': 'Chờ · giờ',
  'prc.in.wh': 'Kho thêm',
  'prc.calc': 'Tính',
  'prc.sur': 'Phụ thu',
  'prc.c.route': 'Tuyến',
  'prc.floor40': 'Sàn 40 ₫',
  'prc.openRoute': 'Mở tính giá · {from} → {to}',
  'prc.toWord': 'đến',
  'prc.noRoute': 'Chưa có tuyến.',
});
addMessages('en', {
  'prc.f.wait': 'Awaiting approval',
  'prc.f.exp': 'Expiring soon',
  'prc.f.below': 'Customers below standard',
  'prc.feeCode': '{code} · fee code',
  'prc.noWrite': 'Write is not enabled in this version',
  'prc.soon': '{what} is not available in this version yet',
  'prc.allSvc': 'All services',
  'prc.title': 'Service price list',
  'prc.roleView': 'Preview as role',
  'prc.mgr': 'Manager',
  'prc.imp': 'Import Excel',
  'prc.exp': 'Export Excel',
  'prc.history': 'Change history',
  'prc.compare': 'Compare prices',
  'prc.add': 'Add price',
  'prc.empty': 'No prices yet',
  'prc.emptyDesc': 'The service price list will appear here.',
  'prc.retry': 'Retry',
  'prc.noperm': 'You do not have permission to view the price list.',
  'prc.service': 'Service',
  'prc.waitN': '{n} awaiting approval',
  'prc.paneLabel': 'Price list · {name}',
  'prc.table': 'Price table',
  'prc.t.std': 'Standard list',
  'prc.t.cus': 'Customer / contract prices',
  'prc.t.sur': 'Scheduled surcharges',
  'prc.rows': 'Number of rows',
  'prc.unfilter': 'Clear filter {f}',
  'prc.unfilterT': 'Clear filter',
  'prc.versions': 'Versions',
  'prc.eff': 'Effective',
  'prc.allVers': 'All versions',
  'prc.routePrice': 'Route pricing',
  'prc.openCalc': 'Open pricing',
  'prc.c.code': 'Code',
  'prc.c.fee': 'Fee name',
  'prc.c.unit': 'Unit',
  'prc.c.calc': 'Calculation',
  'prc.c.std': 'Standard price ₫',
  'prc.c.floor': 'Floor price ₫',
  'prc.c.incl': 'Included',
  'prc.seePrice': 'View price · {code} · {name} · {unit}',
  'prc.priceDetail': 'Price detail',
  'prc.calcT': 'Calculation · {v}',
  'prc.floorT': 'Floor price',
  'prc.inclT': 'Included · {v}',
  'prc.noIncl': 'No inclusion scope',
  'prc.surN': '{n} scheduled surcharges',
  'prc.nextTip': '{v} · {st} · from {from} · {p}',
  'prc.none': 'No prices yet.',
  'prc.c.cus': 'Customer · contract',
  'prc.c.cusPrice': 'Customer price ₫',
  'prc.c.diff': 'Variance',
  'prc.below': 'Below floor',
  'prc.needApr': 'Needs price approval',
  'prc.apr': 'Price approved',
  'prc.belowT': 'Below floor price {floor} · {who}',
  'prc.waitFor': 'awaiting {s}',
  'prc.aprBy': 'approved · {s}',
  'prc.cusDetail': 'Customer price detail',
  'prc.seeCus': 'View customer price · {cus} · {code}',
  'prc.openCt': 'Open contract {ct}',
  'prc.contract': 'Contract',
  'prc.vsStd': 'Compared with standard price',
  'prc.noCus': 'No customer prices yet.',
  'prc.c.appl': 'Applies to',
  'prc.c.item': 'Item',
  'prc.c.formula': 'Formula',
  'prc.c.unitPrice': 'Unit price ₫',
  'prc.c.status': 'Status',
  'prc.noSur': 'No surcharges yet.',
  'prc.trialAria': 'Trial TRFA surcharge calculation',
  'prc.trial': 'Trial calculation · TRFA',
  'prc.in.h': 'Chassis storage · hours',
  'prc.in.w': 'Waiting · hours',
  'prc.in.wh': 'Extra warehouse',
  'prc.calc': 'Calculate',
  'prc.sur': 'Surcharge',
  'prc.c.route': 'Route',
  'prc.floor40': 'Floor 40 ₫',
  'prc.openRoute': 'Open pricing · {from} → {to}',
  'prc.toWord': 'to',
  'prc.noRoute': 'No routes yet.',
});
